import * as promos from 'smg/customer-api/promos';
import QueryString from 'smg/querystring';
import { Relref } from '../hugo';
import { BindSwiperGalleryQuote, WireGalleryQuoteModal } from '../gallery-quote-modal';

main();

function main() {
    const queryPromoCode = QueryString().get('promo') ?? undefined;

    BindSwiperGalleryQuote(({ $body, $link, $img }) => {
        let promoCode = queryPromoCode;

        const $sport = $body.querySelector('#modal-sport') as HTMLSelectElement;
        if ($link.classList.contains('baseball')) {
            $sport.value = 'Baseball';
        } else if ($link.classList.contains('softball')) {
            $sport.value = 'Softball';
        } else {
            $sport.value = '';
        }

        WireGalleryQuoteModal($body, {
            lineItem: 'Lapel Pins',
            type: 'Trading Pins',
            minQty: 100,
            formName: 'baseball trading pins page',
            productLabel: 'Trading Pins',
            notesIntro: 'something like this pin from your "Baseball Trading Pins" gallery',
            imageSrc: $img.src,
            confirmBtnSelector: 'button#modal-confirm-btn',
            reopen: () => $link.click(),
            successRows: () => $sport.value ? [{ label: 'Sport', value: $sport.options[$sport.selectedIndex].text }] : [],
            requestFields: () => ({ promo: promoCode }),
        });

        setTimeout(() => {
            const $promoCodeInput = document.querySelector('#modal-promo') as HTMLInputElement;
            const promoCodeSuccess = document.querySelector('#modal-promo-success') as HTMLElement;
            const promoCodeTitle = promoCodeSuccess.querySelector('#modal-promo-title') as HTMLElement;
            const promoCodeDescription = promoCodeSuccess.querySelector('#modal-promo-description') as HTMLElement;

            new promos.Input($promoCodeInput, {
                success: p => {
                    promoCode = p.code;
                    promoCodeSuccess.classList.remove('d-none');
                    promoCodeTitle.textContent = p.name;
                    promoCodeDescription.textContent = p.description;
                },
                error: () => {
                    promoCode = undefined;
                    promoCodeSuccess.classList.add('d-none');
                },
            });

            $promoCodeInput.value = promoCode ?? '';
            $promoCodeInput.dispatchEvent(new Event('input'));
        });
    }, $link => {
        if (!$link.classList.contains('quote-form-direct')) {
            return false;
        }
        let dest = Relref('/new-trading-pin');
        if (queryPromoCode) {
            dest += `?promo=${queryPromoCode}`;
        }
        window.location.href = dest;
        return true;
    });
}
